import styled from "styled-components";
import { Device } from "../../../../styles/screenSizes";
import { colors } from "../../../../styles/variables";
import Link from "next/link";

export const StyledMenuItem = styled.div<{ isOpen: boolean }>`
  color: ${colors.white};
  cursor: default;
  height: 60px;
  padding: 0 16px;
  margin-right: 16px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${colors.white};
    color: ${({ theme }) => theme.color.primary};
  }

  @media ${Device.notLaptop} {
    color: ${({ theme }) => theme.color.primary};
    background-color: ${colors.white};
    padding: 0 20px;
    margin-right: 0;
    border-bottom: 1px solid ${colors.gray200};

    svg {
      transition: 250ms ease;
    }

    ${({ isOpen }) =>
      isOpen &&
      `
      background-color: ${colors.gray200} !important;
      display: block;
      height: auto;

      svg {
        transform: rotate(180deg);
        transition: 250ms ease;
      }
    `}
  }
`;

export const StyledMenuItemAndCaret = styled.div`
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledNavMenuItemList = styled.div`
  @media ${Device.laptop} {
    color: ${({ theme }) => theme.color.primary};
    background-color: ${colors.white};
    box-shadow: 0 4px 8px 0 ${({ theme }) => theme.color.disabled};
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    position: absolute;
    top: 60px;
    left: 0px;
    width: 250px;

    display: flex;
    flex-direction: column;
  }

  @media ${Device.notLaptop} {
    /* on notLaptop, list is only visible if nav open*/
    display: flex;
    flex-direction: column;
  }
`;

export const StyledLink = styled(Link)`
  @media ${Device.laptop} {
    padding: 16px;
    text-decoration: none;
    color: ${({ theme }) => theme.color.primary};
    cursor: pointer;
    border-bottom: 1px solid ${colors.gray200};

    &:hover {
      background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.05) 0%,
        rgba(0, 0, 0, 0.05) 100%
      );
    }
  }

  @media ${Device.notLaptop} {
    color: ${({ theme }) => theme.color.primary};
    font-size: 16px;
    font-weight: normal;
    height: 40px;
  }
`;
